module.exports = __webpack_public_path__ + "img/placeholder-square-notext.685972c0.png";